module.exports = __webpack_public_path__ + "static/img/SupportTicket.6e0bcb03.svg";